const devSitePrefix = 'devsite:';
const graphQlExplorerPrefix = 'graphiql:';

// note that the devSitePrefix will be added to all keys
export enum DEVSITE_LOCALSTORAGE {
  DETAILED_CONSOLE_LOGS = 'show-detailed-logs',
  TENANT_EXPIRY_TOAST_DISMISSED = 'tenantExpiryToastDismissed',
}

export function getLocalStorage(key: DEVSITE_LOCALSTORAGE) {
  return localStorage.getItem(devSitePrefix + key);
}

export function removeLocalStorage(key: DEVSITE_LOCALSTORAGE) {
  localStorage.removeItem(devSitePrefix + key);
}

export function setLocalStorage(key: DEVSITE_LOCALSTORAGE, value: string) {
  localStorage.setItem(devSitePrefix + key, value);
}

export function clearLocalStorage() {
  Object.keys(localStorage)
    .filter((key) => key.startsWith(devSitePrefix) || key.startsWith(graphQlExplorerPrefix))
    .forEach((key) => localStorage.removeItem(key));
}

export function clearGraphiqlSessionStorage() {
  Object.keys(sessionStorage)
    .filter((key) => key.startsWith(graphQlExplorerPrefix))
    .forEach((key) => sessionStorage.removeItem(key));
}
